<ng-container>
  @let inputs = iconComponentInputs();

  <ftr-icon
    class="icon-button__icon"
    [icon]="icon()"
    [style.color]="inputs.colorStyle"
    [size]="inputs.size"
    [align]="inputs.align"
    ftrTooltip
    [showDash]="false"
    [message]="tooltipMessage()"
    [alignment]="'auto'"
    [anchorElement]="hostElement"
    [position]="tooltipPosition()"
    [alignment]="tooltipAlignment()"
    [ariaHidden]="true"
  />
  <span class="icon-button__content" #buttonContent>
    <ng-content />
  </span>
</ng-container>
